import React, { useState, useCallback } from 'react';
import styled from 'styled-components/macro';
import api from './api';
import EmailForm from './pages/EmailForm';
import CheckEmail from './pages/CheckEmail';
import NameForm from './pages/NameForm';
import RegistrationComplete from './pages/RegistrationComplete';
import PrivacyStatement from './pages/PrivacyStatement';
import GlobalStyle from './GlobalStyle';

const getParam = param =>
  new URLSearchParams(window.location.search).get(param);

const confirmEmailCode = getParam('confirmEmailCode');

const privacyStatement = getParam('privacyStatement');

const App = ({ recaptchaConfig, recaptchaVerified }) => {
  const [submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(
    _getMode(confirmEmailCode, submitted, privacyStatement)
  );

  const handleSubmit = useCallback(() => {
    setSubmitted(true);
    setMode(_getMode(confirmEmailCode, true));
  }, []);

  const handleInvalidConfirmEmailCode = useCallback(
    () => setMode(REGISTER_EMAIL),
    []
  );

  return (
    <Page>
      <GlobalStyle />
      {mode === REGISTER_EMAIL && (
        <EmailForm
          api={api}
          onSubmit={handleSubmit}
          recaptchaConfig={recaptchaConfig}
          recaptchaVerified={recaptchaVerified}
        />
      )}
      {mode === EMAIL_SUBMITTED && <CheckEmail />}
      {mode === REGISTER_NAME && (
        <NameForm
          api={api}
          confirmEmailCode={confirmEmailCode}
          onSubmit={handleSubmit}
          onInvalidConfirmEmailCode={handleInvalidConfirmEmailCode}
        />
      )}
      {mode === NAME_SUBMITTED && <RegistrationComplete />}
      {mode === PRIVACY_STATEMENT && <PrivacyStatement />}
    </Page>
  );
};

const REGISTER_EMAIL = 1,
  EMAIL_SUBMITTED = 2,
  REGISTER_NAME = 3,
  NAME_SUBMITTED = 4,
  PRIVACY_STATEMENT = 5;

const _getMode = (confirmEmailCode, submitted, privacyStatement) => {
  if (privacyStatement) return PRIVACY_STATEMENT;
  if (!confirmEmailCode && !submitted) return REGISTER_EMAIL;
  else if (!confirmEmailCode && submitted) return EMAIL_SUBMITTED;
  else if (confirmEmailCode && !submitted) return REGISTER_NAME;
  else return NAME_SUBMITTED;
};

const Page = styled.div`
  #certiself-form & {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 100px 0 150px;
    color: #484848;
  }
`;

export default App;
